import React, { Component } from "react";
import { Modal } from "react-bootstrap";

class CartProductView extends Component {
  constructor(props) {
    super(props);
  }
  handleCloseModal = () => {
    this.setState({ note: "", place: 0, qty: 1 });
    this.props.hideTrigger();
  };
  handleIncreaseQty = () => {
    this.setState({ qty: this.state.qty + 1 });
  };
  handleDecreaseQty = () => {
    this.setState({ qty: this.state.qty - 1 || 1 });
  };
  render() {
    const productData = this.props.product;
    return (
      <Modal
        show={this.props.trigger}
        className="modal-center"
        onHide={() => this.handleCloseModal()}
      >
        <Modal.Dialog className="modal-sm">
          <Modal.Body className="p-0">
            <div className="d-flex justify-content-end p-1">
              <span
                className="fs-40 material-icons-outlined"
                onClick={() => this.handleCloseModal()}
              >
                close
              </span>
            </div>
            <div className="row">
              <div className="container">
                <div className="row text-center px-20">
                  <div className="text-center pb-10">
                    <img
                      className="avatar avatar-xxl"
                      src={productData.image}
                    />
                    <h5 className="mt-3 mb-1">{productData.name}</h5>
                  </div>
                  <div className="d-flex justify-content-center pb-10">
                    {productData.orderplace === 1 ? (
                      <div className="custom-radio">
                        <label>
                          {/* onClick={() => this.handlePlace(1)} */}
                          <input
                            type="radio"
                            value="1"
                            name="place"
                            defaultChecked={
                              productData.orderplace === 1 ? true : ""
                            }
                          />
                          <div className="box">
                            <div className="row">
                              <span className=" material-icons-outlined fs-30">
                                takeout_dining
                              </span>
                              <span> Take Away</span>
                            </div>
                          </div>
                        </label>
                      </div>
                    ) : (
                      <div className="custom-radio">
                        <label>
                          {/* // onClick={() => this.handlePlace(0)} */}

                          <input
                            type="radio"
                            name="place"
                            defaultChecked={
                              productData.orderplace === 1 ? "" : true
                            }
                          />
                          <div className="box">
                            <div className="row">
                              <span className=" material-icons-outlined fs-30">
                                dining
                              </span>
                              <span> Dine In</span>
                            </div>
                          </div>
                        </label>
                      </div>
                    )}
                  </div>

                  <div className="d-flex justify-content-center py-10">
                    <div className="btn-group">
                      <button
                        className="btn btn-square btn-danger px-35 cart_button"
                        // onClick={() => this.handleDecreaseQty()}
                      >
                        QTY
                      </button>
                      <button
                        className="btn btn-square btn-light px-40 cart_button"
                        disabled="disabled"
                      >
                        {productData.qty}
                      </button>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group p-10">
                      <label htmlFor="textarea">Order Notes</label>
                      <textarea
                        className="form-control"
                        rows="2"
                        readOnly={true}
                        // onChange={(e) => this.handleNote(e.target)}
                        value={productData.prdnote}
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal.Dialog>
      </Modal>
    );
  }
}
export default React.memo(CartProductView);
